import { createApp } from 'vue'
import App from './App.vue'
import { superRouter } from '@/tools'
import { store } from '@/store'
import dayjs from 'dayjs'
import 'virtual:uno.css'
import 'dayjs/locale/zh-cn'
import STable from '@surely-vue/table'
import { authOptsDirective } from '@/directives'

import { Modal } from 'ant-design-vue'

import '@/assets/css/index.scss'
import '@/assets/css/less/index.less'

Modal.props.centered.default = true

dayjs.locale('zh-cn')

const app = createApp(App)

app.use(STable)

app.use(store)

app.use(superRouter.run())

app.directive('auth', authOptsDirective)

app.mount('#app')
